import React from "react";

function MapPin3Icon() {
	return (
		<path d='M11 19.9451C6.50005 19.4476 3 15.6326 3 11C3 6.02944 7.02944 2 12 2C16.9706 2 21 6.02944 21 11C21 15.6326 17.5 19.4476 13 19.9451V24H11V19.9451Z'></path>
	);
}

export default MapPin3Icon;
